import React from "react";
import { CaregiverIndicator, ScreenerResult, SubscaleKey, SubscaleState } from "./scoring";
import { SectionTheme } from "./sections";

const CAREGIVER_LABEL = "Parenting & caregiver wellbeing";

const SUBSCALE_THEMES: Readonly<Record<SubscaleKey, SectionTheme>> = {
  attention: "attention",
  emotional: "emotional",
  behavior: "behavior"
};

function chipModifier(state: SubscaleState | CaregiverIndicator): string {
  return state.toLowerCase().replace(/\s+/g, "-");
}

function Chip({ score, state }: { readonly score?: number; readonly state: SubscaleState | CaregiverIndicator }) {
  return (
    <span className={`screener-chip screener-chip--${chipModifier(state)}`}>
      {score === undefined ? state : `${score} • ${state}`}
    </span>
  );
}

type SubscaleListProps = {
  readonly result: ScreenerResult;
};

export default function SubscaleList({ result }: SubscaleListProps) {
  return (
    <div className="screener-card screener-subscales">
      {result.subscales.map(subscale => (
        <div key={subscale.key} className="screener-subscale">
          <span className={`screener-subscale__label screener-subscale__label--${SUBSCALE_THEMES[subscale.key]}`}>
            <span className="screener-subscale__dot" aria-hidden="true" />
            {subscale.label}
          </span>
          <Chip score={subscale.score} state={subscale.state} />
        </div>
      ))}
      <div className="screener-subscale">
        <span className="screener-subscale__label screener-subscale__label--parenting">
          <span className="screener-subscale__dot" aria-hidden="true" />
          {CAREGIVER_LABEL}
        </span>
        <Chip state={result.caregiverIndicator} />
      </div>
    </div>
  );
}
